// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import * as R from "ramda"

import fetchApi from "./api"

const SET_LOCALE = "options/SET_LOCALE"
const FETCH_LOCALE = "options/FETCH_LOCALE"
// const FETCH_LOCALE_REQUEST = "options/FETCH_LOCALE_REQUEST"
const FETCH_LOCALE_SUCCESS = "options/FETCH_LOCALE_SUCCESS"
// const FETCH_LOCALE_FAILURE = "options/FETCH_LOCALE_FAILURE"

// NEW TRANSLATIONS
// ===
// only for development
// when merging PR, upload these to PhraseApp to be actually translated

// use flat format {"a.b.c": "text"}
// ---

// ------------------------ temp place for translations - don't let it in master -----------------------
//

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NEW_TRANSLATIONS: Record<string, any> = {}

// -------------------------------------- this is on master---------------------------------------------

type Action = {
  type: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  res: Record<any, any>
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export type IntlState = {
  [key: string]: string
}

export default function translationsReducer(
  state: IntlState | null | undefined = {},
  action: Action,
) {
  switch (action.type) {
    case FETCH_LOCALE_SUCCESS:
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return NEW_TRANSLATIONS ? R.mergeDeepRight(action.res, NEW_TRANSLATIONS) : action.res

    case SET_LOCALE:
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return NEW_TRANSLATIONS ? R.mergeDeepRight(action.res, NEW_TRANSLATIONS) : action.res

    default:
      return state
  }
}

export const fetchLocale = (loc: string) => ({
  type: FETCH_LOCALE,
  promise: fetchApi(loc),
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setLocale = (translations: any): Action => ({
  type: FETCH_LOCALE_SUCCESS,
  res: translations,
})

type State = {
  readonly translations: IntlState
}

export const getTranslations = (state: State) => state.translations
